<template>
  <carousel
    :controls="true"
    :perPage="1"
    :autoplay="false"
    :loop="true"
    :speed="1000"
  >
    <slide>
      <img src="../assets/img/unsplash1.jpg" style="width: 80%;" />
    </slide>
    <slide>
      <img src="../assets/img/unsplash2.jpg" style="width: 80%;" />
    </slide>
    <!-- <slide v-for="(image, i) in images" :key="i">
      <img :src="`${image}`" style="width: 80%;" />
    </slide> -->
  </carousel>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";

export default {
  name: "ImgCarousel",
  components: {
    Carousel,
    Slide
  },
  data: () => ({
    images: [
      "../assets/img/unsplash1.jpg",
      "../assets/img/unsplash2.jpg",
      "../assets/img/unsplash3.jpg",
      "../assets/img/unsplash4.jpg"
    ]
  })
};
</script>

<style scoped>
/* .img-slide {
  width: 300px;
  max-width: 100%;
} */
</style>
